import Select from 'react-select';
import 'react-select/dist/react-select.css';

interface FlagFilterSelectProps {
  labelText: string;
  onChange: () => void;
  options: string[];
  placeholder?: string;
  value: string;
  onFocus?: () => void;
}

function FlagFilterSelect({
  labelText,
  onChange,
  options,
  placeholder,
  value,
  onFocus
}: FlagFilterSelectProps) {
  return (
    <>
      {labelText}
      <Select
        style={{ wordBreak: 'break-all' }}
        multi
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        simpleValue
        value={value}
        onFocus={onFocus}
      />
    </>
  );
}

export default FlagFilterSelect;
